
/*
Defines the custom element <ravel-scrapbook>
*/

import { RavelScrapbook } from './src/RavelScrapbook.js';

customElements.define('ravel-scrapbook', RavelScrapbook);
